const enableChangeTextColorTab = (enabled, toolbox, getColorFunction) => {
  // できれば通常の色変更と処理を共通化したい
  if (enabled) {
    // カラーパレットの切り替え
    (toolbox.find(".tab-menu__item") as JQuery<HTMLElement>).on(
      "click",
      function () {
        $(this).parent().children().removeClass("is-select");
        $(this).parent().children().prop("disabled", false);
        $(this).addClass("is-select");
        $(this).prop("disabled", true);
        // カラーパレットの選択中の色も変える
        const color = getColorFunction($(this).data("target"));
        changeColorchip(color, toolbox);
      }
    );
  } else {
    toolbox.find(".tab-menu__item").off("click");
    // カラーパレットの選択中の色も変える
    const color = getColorFunction(
      toolbox.find(".tab-menu__item--text").data("target")
    );
    changeColorchip(color, toolbox);
  }
};

export const changeColorchip = (color, toolbox) => {
  toolbox.find(".colorchip").removeClass("is-select");
  toolbox.find("#colorchip-" + color).addClass("is-select");
};

export const showBorderTab = (enabled, toolbox, getColorFunction) => {
  // できれば通常の色変更と処理を共通化したい
  if (enabled) {
    toolbox.find(".tab-menu__item--border").removeClass("is-hidden");
  } else {
    toolbox.find(".tab-menu__item--border").addClass("is-hidden");
    // 縁の色が選択されている場合もあるので、その場合は強制的に戻す
    toolbox.find(".tab-menu__item--border").removeClass("is-select");
    toolbox.find(".tab-menu__item--border").prop("disabled", false);
    toolbox.find(".tab-menu__item--text").addClass("is-select");
    toolbox.find(".tab-menu__item--text").prop("disabled", true);
  }
  enableChangeTextColorTab(enabled, toolbox, getColorFunction);
};
